<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card flat>
          <v-card-title>
            Authorizations
            <v-spacer></v-spacer>
            <v-btn 
              v-if="!isElderoneClient"
              class="me-3" 
              href="https://clearspring.access.mcg.com/index" 
              target="_blank" 
              color="success"
            >
              Milliman Guidelines
            </v-btn>
            <new-authorization :user="user" @newAuth="addAuth" />
          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="4" md="6" lg="2" class="py-0">
                <v-select :items="AuthItems" v-model="completed" />
              </v-col>
            </v-row>

            <div>
              <v-data-table
                :loading="load"
                :headers="headers"
                :items="completed !== 'All' ? unassignedFilteredData : unassignedData"
                :search="search"
                :footer-props="{ 'items-per-page-options': [15, -1] }"
                sort-by="CreatedDT"
                sort-desc
                multi-sort
                loading-text="Loading data..."
                class="elevation-0 col-md-12 m-auto"
              >
                <template v-slot:item.Actions="{ item }">
                  <!--                        <v-btn text>-->
                  <!--                          <v-icon @click="openDeleteDialog(item)"> mdi-delete </v-icon>-->
                  <!--                        </v-btn>-->

                  <auth-modal :authID="item.AUTH_ID" :user="user"></auth-modal>
                </template>

                <template v-slot:item.SERVICES_WITH_HCPCS="{ item }">
                  <auth-services-modal
                    :services="item.SERVICES_WITH_HCPCS"
                    v-model="servicesModal"
                  ></auth-services-modal>
                </template>

                <template v-slot:item.SERVICES_WITH_DIAGNOSIS="{ item }">
                  <auth-services-modal
                    :services="item.SERVICES_WITH_DIAGNOSIS"
                    v-model="servicesModal"
                  ></auth-services-modal>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>

        <v-dialog v-model="deleteAuthDialog" persistent max-width="600px">
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                Are you sure you want to delete this Authorization?
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="deleteAuthDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="mt-3">
              Deleting an Authorization is a permenant action. Please confirm that you wish to
              remove this notification from the system.
              <v-card-actions>
                <v-spacer />
                <v-btn @click="deleteAuth()" text color="Error"> Delete </v-btn>

                <v-btn @click="deleteAuthDialog = false" text color="primary"> Cancel </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-snackbar v-model="deleteSuccess" color="success" :timeout="2000">
          Authorization successfully deleted
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackInfo = false"> Close </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import NewAuthorization from '../components/auths/NewAuthorization.vue';
import AuthModal from '../components/auths/AuthModal.vue';
import AuthServicesModal from '../components/auths/AuthServicesModal.vue';

export default {
  name: 'Authorizations',
  components: {
    NewAuthorization,
    AuthModal,
    AuthServicesModal,
  },
  data() {
    return {
      user: '',
      setServicesData: [],
      servicesModal: false,
      completed: 'All',
      tab: null,
      tabs: ['Unassigned', 'Nurse', 'MD'],
      load: false,
      search: '',
      reportData: [],
      unassignedData: [],
      unassignedCompletedData: [],
      AuthItems: ['All', 'Completed', 'Uncompleted'],
      headers: [
        { text: 'Date Created', value: 'CREATED_DT' },
        { text: 'Authorization ID', value: 'AUTH_ID' },
        { text: 'Patient Member ID', value: 'SUBSCRIBER_ID' },
        { text: 'Member Name', value: 'MEMBER_NAME' },
        { text: 'Determintation', value: 'DETERMINATION' },
        { text: 'Services', value: 'SERVICES_WITH_HCPCS' },
        { text: 'Diagnosis', value: 'SERVICES_WITH_DIAGNOSIS' },
        { text: 'Requesting Provider Name', value: 'REQ_PROVIDER_NAME' },
        { text: 'Actions', value: 'Actions' },
      ],
      deleteAuthDialog: false,
      authToDelete: {},
      deleteSuccess: false,
    };
  },
  computed: {
    isElderoneClient() {
      return process.env.VUE_APP_CUSTOMER === 'Elderone';
    },
  },
  methods: {
    getUser() {
      axios
        .get('/api/user')
        .then((response) => {
          this.user = response.data[0];
          // check role and reroute if unauthorized
          if (this.user.role === 'agent' || this.user.role === 'fmo') {
            this.$router.push('/');
          } else if (this.user.role === 'credentialing') {
            this.$router.push('/credentialing');
          } else {
            this.getReportData();
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$router.push("/login");
        });
    },
    async getReportData() {
      await axios.get('/api/authorizations/getAllAuthorizations').then((res) => {
        let allData = res.data;
        this.unassignedData = [];
        this.nurseData = [];
        this.mdData = [];

        allData.forEach((authObj) => {
          // if (authObj.REVIEW_STATUS === 'Unassigned' || authObj.REVIEW_STATUS === null) {
            this.unassignedData.push(authObj);
          // } else if (authObj.REVIEW_STATUS === 'Nurse') {
          //   this.nurseData.push(authObj);
          // } else if (authObj.REVIEW_STATUS === 'MD') {
          //   this.mdData.push(authObj);
          // }
          //
          // if (authObj.DETERMINATION === null) {
          //   this.DETERMINATION = 'Pending';
          //
          // }
        });
      });
    },
    openServicesModal() {
      this.servicesModal = true;
    },
    addAuth(e) {
      // if (e.REVIEW_STATUS === 'Unassigned') {
        this.unassignedData.push(e);
      // } else if (e.REVIEW_STATUS === 'Nurse') {
      //   this.nurseData.push(e);
      // } else if (e.REVIEW_STATUS === 'MD') {
      //   this.mdData.push(e);
      // }
    },
    openDeleteDialog(auth) {
      this.authToDelete = auth;
      this.deleteAuthDialog = true;
    },
    async deleteAuth() {
      await axios.post(`/api/authorizations/delete/${this.authToDelete.AUTH_ID}`).then(() => {
        // Remove item from table in correct tab
        // if (this.tab === 0) {
          let deletedItem = this.unassignedData.indexOf(this.authToDelete);

          this.unassignedData.splice(deletedItem, 1);
          this.$nextTick(() => {
            this.deletedItem = -1;
          });
        // } else if (this.tab === 1) {
        //   let deletedItem = this.nurseData.indexOf(this.authToDelete);
        //
        //   this.nurseData.splice(deletedItem, 1);
        //   this.$nextTick(() => {
        //     this.deletedItem = -1;
        //   });
        // } else if (this.tab === 2) {
        //   let deletedItem = this.mdData.indexOf(this.authToDelete);
        //
        //   this.mdData.splice(deletedItem, 1);
        //   this.$nextTick(() => {
        //     this.deletedItem = -1;
        //   });
        // }

        this.deleteAuthDialog = false;
        this.deleteSuccess = true;
      });
    },
  },
  mounted() {
    this.getUser();
  },
  watch: {
    completed() {
      this.unassignedFilteredData = [];
      // this.nurseFilteredData = [];
      // this.mdFilteredData = [];
      if (this.completed === 'Completed') {
        this.unassignedData.forEach((obj) => {
          if (obj.DETERMINATION !== 'Pending') {
            this.unassignedFilteredData.push(obj);
          }
        });
        // this.nurseData.forEach((obj) => {
        //   if (obj.DETERMINATION !== 'Pending') {
        //     this.nurseFilteredData.push(obj);
        //   }
        // });
        // this.mdData.forEach((obj) => {
        //   if (obj.DETERMINATION !== 'Pending') {
        //     this.mdFilteredData.push(obj);
        //   }
        // });
      } else if (this.completed === 'Uncompleted') {
        this.unassignedData.forEach((obj) => {
          if (obj.DETERMINATION === 'Pending') {
            this.unassignedFilteredData.push(obj);
          }
        });
        // this.nurseData.forEach((obj) => {
        //   if (obj.DETERMINATION === 'Pending') {
        //     this.nurseFilteredData.push(obj);
        //   }
        // });
        // this.mdData.forEach((obj) => {
        //   if (obj.DETERMINATION === 'Pending') {
        //     this.mdFilteredData.push(obj);
        //   }
        // });
      }
    },
  },
};
</script>

<style scoped>
.export-button {
  position: absolute;
  left: 15px;
  bottom: 30px;
}
</style>
